import script from "./FileChangesView.vue?vue&type=script&setup=true&lang=js"
export * from "./FileChangesView.vue?vue&type=script&setup=true&lang=js"

import "./FileChangesView.vue?vue&type=style&index=0&id=0137273e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0137273e"]])

export default __exports__